import { isNativeMobileApp } from '@/addons/mobile'

import { initWebPushNotification } from './web'
import { initMobilePushNotification } from './mobile'
import { ConfigGetters } from '@/store/configs-store'
import store from '@/store'

export const initPushNotification = () => {
  const fcmToken = store.getters[ConfigGetters.GET_FCM_TOKEN] ?? undefined

  if (!fcmToken) {
    if (isNativeMobileApp()) {
      initMobilePushNotification()
    } else {
      initWebPushNotification()
    }
  }
}
